var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoyalNewImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2239_8)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M14.9844 3.96875C15.5188 3.64062 15.875 3.04531 15.875 2.375C15.875 1.33906 15.0359 0.5 14 0.5C12.9641 0.5 12.125 1.33906 12.125 2.375C12.125 3.05 12.4812 3.64062 13.0156 3.96875L10.3297 9.34063C9.90312 10.1938 8.79688 10.4375 8.05156 9.84219L3.875 6.5C4.10938 6.18594 4.25 5.79688 4.25 5.375C4.25 4.33906 3.41094 3.5 2.375 3.5C1.33906 3.5 0.5 4.33906 0.5 5.375C0.5 6.41094 1.33906 7.25 2.375 7.25C2.38437 7.25 2.39844 7.25 2.40781 7.25L4.55 19.0344C4.80781 20.4594 6.05 21.5 7.50312 21.5H20.4969C21.9453 21.5 23.1875 20.4641 23.45 19.0344L25.5922 7.25C25.6016 7.25 25.6156 7.25 25.625 7.25C26.6609 7.25 27.5 6.41094 27.5 5.375C27.5 4.33906 26.6609 3.5 25.625 3.5C24.5891 3.5 23.75 4.33906 23.75 5.375C23.75 5.79688 23.8906 6.18594 24.125 6.5L19.9484 9.84219C19.2031 10.4375 18.0969 10.1938 17.6703 9.34063L14.9844 3.96875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2239_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoyalNewImage);
export default __webpack_public_path__ + "static/media/royal-new-image.46dc2097fa6c57d169f83684e572c10d.svg";
export { ForwardRef as ReactComponent };